import type { ComponentType } from "@bcc/core-renderers";
import type { ComponentDefinition } from "./pageComponentLibrary.types";
import { componentDefinitionMap } from "./pageComponentLibrary.definitions";

/** Legacy alias identifiers → canonical type (payloads may use either name). */
export const COMPONENT_TYPE_ALIASES: Record<string, ComponentType> = {
	HomeHero: "Hero",
	HomeNews: "NewsSection",
	HomeBlueStats: "StatsSummary",
	HomeBlueTools: "AudienceTools",
	HomePubUpdatesSection: "PublicationsUpdates"
};

/** Definition lookup that resolves alias componentTypes to their canonical definition. */
export function resolveComponentDefinition(type: string | undefined | null): ComponentDefinition | null {
	if (!type) return null;
	return (
		componentDefinitionMap.get(type as ComponentType) ??
		componentDefinitionMap.get(COMPONENT_TYPE_ALIASES[type] as ComponentType) ??
		null
	);
}
